// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"161":"6447fad2","318":"95770d03","707":"c480c193","994":"a060c18f"}[chunkId] + ".js";
};